import React from 'react';
import PropTypes from 'prop-types';

import { Button, ClipboardIcon } from '@spotahome/ui-library';

import './ReferralCopy.scss';

const ReferralCopy = ({
  label,
  referralData,
  onCopy,
  isCopied,
  ctaCopyLabel,
  ctaCopiedLabel,
  dataTest
}) => (
  <div className="referralCopy__content">
    <p className="referralCopy__content-title">{label}</p>
    <input
      className="referralCopy__input"
      value={referralData}
      readOnly
      data-test={dataTest}
      onClick={onCopy}
    />
    <Button className="referralCopy__button" onClick={onCopy}>
      {isCopied ? '' : <ClipboardIcon className="referralCopy__icon" />}
      <span className="CTA__label">
        {isCopied ? ctaCopiedLabel : ctaCopyLabel}
      </span>
    </Button>
  </div>
);

ReferralCopy.defaultProps = {
  label: ''
};

ReferralCopy.propTypes = {
  /* Label that explains to user what the referral thing is (code or link) */
  label: PropTypes.string,
  /* Referral data to be copied (code or link) */
  referralData: PropTypes.string.isRequired,
  /* Event triggered when CTA is clicked */
  onCopy: PropTypes.func.isRequired,
  /* Whether referralData is copied or not */
  isCopied: PropTypes.bool.isRequired,
  /* CTA text displayed when referralData is not copied */
  ctaCopyLabel: PropTypes.string.isRequired,
  /* CTA text displayed when referralData is copied */
  ctaCopiedLabel: PropTypes.string.isRequired,
  /* For Test purposes */
  dataTest: PropTypes.string.isRequired
};

export default ReferralCopy;
